// src/api/auth.js
import api from './api';

export const authAPI = {
    // logout method
    logout: async () => {
        try {
            const response = await api.post('/auth/logout');
            return response.data;
        } catch (error) {
            console.error('Error in logout :', error);
            throw error;
        }
    },

    // onboarding method
    onboarding: async () => {
        try {
            const response = await api.post('/auth/onboarding');
            return response.data;
        } catch (error) {
            console.error('Error in onboarding :', error);
            throw error;
        }
    }
};

export default authAPI;
